import React from 'react';
import ImgComparisonNova from 'assets/img/premium/comparison-nova.jpg';
import ImgComparisonNovaSM from 'assets/img/premium/comparison-nova-sm.jpg';
import './FreePremium.css';

type Props = {
  isNova?: boolean;
  tier?: string;
};

const FreePremium: React.FC<Props> = ({isNova = true, tier = 'free'}) => {
  return (
    <>
      <h3 className="dashboard-profile-title"><span className="text-gradient text-gradient--premium">選擇 ELSA Premium 套餐，</span>全面解鎖所有功能，快速提升您的英語能力！</h3>
      <div className="card-package">
        <div className="card-package__panel">
          <div className="card-package-header">
            <picture>
              <source srcSet={ImgComparisonNova} media="(min-width: 768px)" />
              <img src={ImgComparisonNovaSM} alt="Comparison" />
            </picture>
          </div>

          {/* <div className="card-package-body">
            <h3 className="card-package-body__title">Luncurkan <span className="text-gradient text-gradient--ai">ELSA AI</span> secara resmi</h3>
            <p>Dialog langsung dengan AI</p>
            <Link to='/elsa-premium' className="btn-primary">Daftar sekarang</Link>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default FreePremium;
